export const ENGAGE_SOLUTION_FEATURES = [
  'Golden Profile Creation',
  'Targeting',
  'AI Marketing Invites',
  'Guest Reviews & Ratings',
  'Analytics & Reporting'
]

export const ENGAGE_PLUS_SOLUTION_FEATURES = [
  'Day Before Check-In, After Check-in messages',
  'In-House Guest: Announcements',
  'In-House Guest: Messages',
  'In-House Guest: Chatbot'
]

export const EMAIL_DRIP_CAMPAIGN_FEATURE = 'Email Drip Campaigns'
export const CART_ABANDONMENT_FEATURE = 'Cart Abandonment'

const PLAN_TIER_LABELS = {
  engage: 'Directful Engage',
  engagePlus: 'Directful Engage+'
}

export function getAvailableSolutionFeatures({
  tier,
  hasEmailDrip = false,
  hasCartAbandonment = false
} = {}) {
  const sections = []

  if (tier === 'engage' || tier === 'engagePlus') {
    sections.push({
      title: 'Engage',
      features: [...ENGAGE_SOLUTION_FEATURES]
    })
  }

  if (tier === 'engagePlus') {
    sections.push({
      title: 'Engage+',
      features: [...ENGAGE_PLUS_SOLUTION_FEATURES]
    })
  }

  const addOnFeatures = []
  if (hasEmailDrip) {
    addOnFeatures.push(EMAIL_DRIP_CAMPAIGN_FEATURE)
  }
  if (hasCartAbandonment) {
    addOnFeatures.push(CART_ABANDONMENT_FEATURE)
  }

  if (addOnFeatures.length) {
    sections.push({
      title: 'Add-ons',
      features: addOnFeatures
    })
  }

  return {
    planLabel: PLAN_TIER_LABELS[tier] || null,
    sections
  }
}
